@if (simulation.available()) {
      @if (simulation.activeUser(); as user) {
        <span role="status">{{ 'userSimulation.active' | translate }}: {{ user.displayName }} · {{ user.role }}</span>
        <button type="button" (click)="simulation.stop()">{{ 'userSimulation.stop' | translate }}</button>
      }
      <details>
        <summary>{{ 'userSimulation.title' | translate }}</summary>
        <div class="simulation-menu">
        <label>
          {{ 'userSimulation.search' | translate }}
          <input type="search" [value]="query()" (input)="query.set($any($event.target).value)">
        </label>
        @if (directory().error) {
          <p role="alert">{{ 'userSimulation.error' | translate }}</p>
        } @else if (directory().loading) {
          <p role="status">{{ 'userSimulation.loading' | translate }}</p>
        } @else {
          <label>
            {{ 'userSimulation.select' | translate }}
            <select #selection [value]="simulation.activeUser()?.guid ?? ''" (change)="simulation.start(selection.value)">
              <option value="">{{ 'userSimulation.select' | translate }}</option>
              @for (user of filteredUsers(); track user.guid) {
                <option [value]="user.guid">{{ user.label }}</option>
              }
            </select>
          </label>
          @if (!filteredUsers().length) {
            <p>{{ 'userSimulation.empty' | translate }}</p>
          }
        }
        </div>
      </details>
    }
